<script>
const timeSound = require('../../assets/audio/time.mp3')
export default {
	props: {
		question: {
			type: Object,
		},

		score: {
			type: Number,
			default() {
				return 0
			}
		},

		comodin50: {
			type: Boolean,
			default() {
				return true
			}
		},
		
		comodinRescue : {
			type: Boolean,
			default() {
				return true
			}
		},

		comodines: {
			type: Boolean,
			default() {
				return true
			}
		},

		number: {
			type: Number,
			default() {
				return 1
			}
		},

		count: {
			type: Number
		},

		timerShow: {
			type: Boolean,
			default() {
				return true
			}
		},

		random: {
			type: Boolean,
			default() {
				return true
			}
		}


	},

	data() {
		return {
			literals: ['a','b','c','d','e','f'],
			time: 40,
			timerOn: true,
			selected: null,
			timer: null,
			wrongs: [],
			timeSound: new Audio(timeSound),
			indexPrev: 0
		}
	},

	computed: {
		options() {
			let options = this.question.options.map(opt => Object.assign({}, opt))
			if(this.random) {
				return options.sort(function(){return 0.5 - Math.random()})
			}
			return options
		},

		avatarMessage() {
			let messages = ['¡Seguro te acuerdas!', '¡Tu puedes!', '¿Lo recuerdas?', '¿Cómo vamos?', '¡Tú tienes la respuesta!', '¡Piensa bien tu respuesta!']
 
			if(this.number == 1) {
				messages = ['¡Iniciemos!', 'Nuestra primera pregunta es la siguiente']
			}

			if(this.number == 9) {
				return 'Falta poco ¡tu puedes!'
			}
			if(this.number == this.count) {
				return '¡Casi lo has logrado!'
			}

			return messages[Math.floor(Math.random() * messages.length)];
		}
	},

	methods: {
		countdown() {
			if(this.timerShow) {
				if(this.time > 0) {
					if(this.time < 11) {
						this.timeSound.play()
					}
					this.timer = setTimeout(() => {
						this.time--
						this.countdown()
					}, 1000)
				} else {
					this.timeOut()
				}
			}
		},

		selectOption(optionId) {
			if(this.wrongs.includes(optionId) || !this.time) {
				return
			}
			this.selected = optionId
		},

		nextQuestion() {
			let data = {
				id: this.question.id,
				answer: this.selected
			}
			this.$emit('nextQuestion', data) 
		},

		prevQuestion() {
			this.indexPrev++
			this.timeOn = false
			this.$emit('prevQuestion', (this.indexPrev)) 
		},

		timeOut() {
			let data = {
				id: this.question.id,
				answer: this.selected
			}

			this.$emit('timeOut', data)
		},
		useComodin50() {
			if(!this.time) return
			this.$emit('useComodin50')
			let optionsCount = Math.floor(this.options.length / 2)
			let wrongsAnswers = this.options.filter(opt => !this.question.answers.includes(opt.id))
								.sort(function(){return 0.5 - Math.random()})
								.slice(0, optionsCount)
			this.wrongs = wrongsAnswers.map(w => w.id)
		},

		useComodinRescue() {
			if(!this.time) return
			this.$emit('useComodinRescue', this.question.id)
		}
	},

	mounted() {
		this.countdown()
	},

	destroyed() {
		clearTimeout(this.timer)
		this.timeSound.pause()
		this.timeSound.remove()
	}
}
</script>
<template>
	<div class="wrapper">
		<div class="quiz__header d-flex justify-content-between p-0">
			<div class="col-4">
				<div>
					<h6>Puntos</h6>
					<button class="quiz__comodin mt-3">
						{{score}}
					</button>
				</div>
			</div>
			<div class="col-2">
				<h6 v-if="comodines">Comodin</h6>
				<div class="d-flex justify-content-center py-3" v-if="comodines">
					<div v-if="comodin50" class="px-3">
						<button @click="useComodin50" class="quiz__comodin">
							<span>50</span>
							<span>50</span>
						</button>
					</div>
					<div v-if="comodinRescue" class="px-3">
						<button @click="useComodinRescue" class="quiz__comodin quiz__comodin--2">
							<img src="../../assets/svg/change.svg" alt="">
						</button>
					</div>
				</div>
			</div>
			<div class="col-2">
				<div v-if="timerShow" class="quiz__timer">
					<span class="quiz__timer-time">00:{{time | numeral('00')}}</span>
				</div>
				
			</div>
			<div class="col-4">
				<div>
					<h6>Pregunta</h6>
					<button class="quiz__comodin mt-3">
						{{number}}/{{count}}
					</button>
				</div>
			</div>
		</div>
		
		<div class="d-flex justify-content-center mt-3 py-2 quiz__question-area">
			<div class="col-11 col-lg-8 col-xl-7 px-3 d-flex flex-direction-column">
				<div class="w-100 my-auto">
					<div class="text-center px-2 quiz__question-header">
						<p class="quiz__question" :class="{'quiz__question--rescue': (number === count && !comodinRescue)}">
							{{ question.title }}
							<span v-if="(number === count && !comodinRescue)" class="quiz__question-label">
								Esta es la pregunta comodin
							</span>
							<!-- <span class="quiz__avatar-message">{{avatarMessage}}</span> -->
						</p>
					</div>
					
					<div v-for="(option, index) in options" :key="`option-${index}-${option.id}`" 
					class="quiz__option px-4" 
					:class="{
						'quiz__option--selected': (option.id === selected),
						'quiz__option--wrong': wrongs.includes(option.id),
						'quiz__option--disabled': time === 0,
					}" 
					@click="selectOption(option.id)">
						<p class="quiz__option-text px-4 py-3 m-0">{{option.text}}</p>
						<span class="quiz__option-literal">{{literals[index]}})</span>
					</div>
				</div>

				<transition name="zoom">
					<button v-if="selected || !time" class="quiz__nav quiz__nav--mobile ml-5 d-block d-lg-none" @click="nextQuestion">
						<span>Siguiente</span><img class="mr-n1" src="../../assets/svg/next.svg" alt="">
					</button>
				</transition>
				
			</div>
			<div class="d-none d-lg-block col-2 col-md-6 col-lg-4">
				<div class="quiz__avatar-wrap">
					<div class="position-relative">
						<span class="quiz__avatar-message">
							<span v-if="time == 0">
								Se acabo el tiempo, pasa a la siguiente pregunta
							</span>
							<span v-else-if="time <= 10">
								Se acabo el tiempo, pasa a la siguiente pregunta
							</span>
							<span v-else>
								{{avatarMessage}}
							</span>
						</span>
						<img v-if="time == 0" class="d-none d-md-block quiz__avatar" src="../../assets/svg/avatar-36.svg" alt="">
						<img v-else-if="time <= 10" class="d-none d-md-block quiz__avatar" src="../../assets/svg/avatar-35.svg" alt="">
						<img v-else class="d-none d-md-block quiz__avatar" src="../../assets/svg/avatar-30.svg" alt="">
					</div>
					<div class="text-center mt-3" >
						<transition name="zoom">
							<button v-if="selected || !time" class="quiz__nav ml-5" @click="nextQuestion">
								<span>Siguiente</span><img class="mr-n1" src="../../assets/svg/next.svg" alt="">
							</button>
						</transition>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
.wrapper{
	background-image: url('../../assets/img/evaluations/bg_02.png');
	background-attachment: fixed;
	background-size: cover;
	position: relative;
	display: flex;
	flex-direction: column;
	max-height: calc(100% - 60px);;
}
.quiz{
	&__header{
		color: #fff;
		text-align: center;
	}
	&__question-area{
		flex-grow: 1;
		height: 50%;
		overflow: auto;
		max-width: 1300px;
		width: 100%;
		margin-left: auto;
		margin-right: auto;

	}
	&__nav{
		border: 0;
		padding: 0;
		height: 50px;
		border-radius: 50px;
		white-space: nowrap;
		padding: 0 1rem;
		text-transform: uppercase;
		font-weight: 700;
		outline: none !important;
		position: absolute;
		bottom: 0;
		left: 0;
		transform: translateX(-50%);
		img{
			width: 40px;
		}
		&--mobile{
			position: fixed;
			right: 1rem;
			left: auto;
			bottom: 60px;
		}
	}
	&__avatar{
		// transform: translateX(-1rem) translateY(-1rem);
		width: 90%;
		pointer-events: none;

		&-wrap{
			position: fixed;
			right: 15px;
			width: 35%;
			bottom: 60px;
			z-index: 91;
		}
		&-message{
			color: #fff;
			background-color: #3280BC;
			display: inline-block;
			padding: 0.5rem 1em;
			font-size: 0.9em;
			border-radius: 0.75em;
			position: absolute;
			top: 0;
			left: 5px;
			font-weight: 300;
			max-width: 45%;
			z-index: 0;
			&::before{
				content: '';
				position: absolute;
				top: 100%;
				right: 1em;
				border-bottom: 0 transparent;
				border-left: 2em solid transparent;
				border-right: 0 solid transparent;
				border-top: 5em solid #3280BC;
			}
		}
	}
	&__option{
		margin: 0.9rem auto;
		position: relative;
		@media (min-width: 1300px) {
			margin: 1.1rem auto;
		}
		&-text{
			color: #fff;
			background-color: #3080BB;
			border-radius: 1.5rem;
			font-size: 0.8em;
			transition: 0.1s;
			@media (min-width: 1300px) {
				font-size: 0.85em;
			}
		}
		&-literal{
			background-color: #fff;
			color: #000;
			font-size: 1.1em;
			display: inline-block;
			width: 1.5em;
			height: 1.5em;
			text-align: center;
			border-radius: 50%;
			top: 50%;
			transform: translateY(-50%);
			position: absolute;
			left: 0%;
			&::before{
				content: '';
				position: absolute;
				display: inline-block;
				width: 120%;
				height: 120%;
				background-color: transparent;
				top: -10%;
				left: -10%;
				z-index: -2;
				border-radius: 50%;
				box-shadow: 0 0 0 2px #3080BB;
				transition: 0.1s;
			}
		}
		&--selected{
			.quiz{
				&__option{
					&-text{
						box-shadow: 0 0 0 4px #2DCCCD;
						// font-size: 0.9em;
					}
					&-literal{
						&::before{
							width: 100%;
							height: 100%;
							top: 0%;
							left: 0%;
							box-shadow: 0 0 0 4px #2DCCCD;
						}
					}
				}
			}
		}
		&--wrong{
			opacity: 0.5;
			filter: grayscale(0.5);
		}
		&--disabled{
			opacity: 0.5;
			filter: grayscale(1);
		}
		&:hover{
			transform: scale(1.1);
		}
		&--wrong,
		&--disabled{
			&:hover{
				transform: scale(1);
			}
		}

	}
	&__question{
		background-color: #fff;
		padding: 1rem;
		display: inline-block;
		width: 100%;
		font-size: 0.9em;
		border-radius: 1.5rem;
		position: relative;
		margin-bottom: 0.9em;
		font-weight: 700;
		&::before,
		&::after{
			content: '';
			position: absolute;
			display: inline-block;
			width: 0.5rem;
			height: 100%;
			background: #F05E5E;
			left: -1rem;
			top: 0;
		}
		&::before{
			right: -1rem;
			left: auto;
		}
		&--rescue{
			&::before,
			&::after{
				background: #F6CD51;
			}
		}
		&-header{
			position: sticky;
			top: 0;
			z-index: 90;
		}
		&-label{
			position: absolute;
			right: 50%;
			font-size: 0.7em;
			background-color: #F6CD51;
			/* width: 150px; */
			padding: 0.5em 1em;
			transform: translateX(50%) translateY(-30%);
			border-radius: 25px;
			top: 100%;
		}
	}
	&__timer{
		width: 100px;
		padding-bottom: 100px;
		margin: 0 auto;
		position: relative;
		background-image: url('../../assets/svg/timer.svg');
		background-repeat: no-repeat;
		background-position: center center;
		&-time{
			position: absolute;
			top: 50%;
			left: 0;
			width: 100%;
			transform: translateY(-25%);
			color: #2DCCCD;
			font-size: 1em;
			text-align: center;
		}
	}
	&__comodin{
		position: relative;
		background: #fff;
		padding: 0;
		width: 40px;
		height: 40px;
		display: inline-block;
		border-radius: 50%;
		border: 0 none;
		font-weight: 700;
		color: #000000;
		outline: none !important;
		span{
			font-size: 0.9em;
			&:nth-of-type(1) {
				vertical-align: super;
			}
			&:nth-child(2) {
				vertical-align: sub;
			}
		}
		img{
			width: 50%;
		}
		&::after{
			content: '';
			background-image: url('../../assets/svg/decorator.svg');
			position: absolute;
			display: inline-block;
			width: 150%;
			height: 150%;
			left: -25%;
			top: -25%;
			animation: comodin 2s linear infinite;
		}
		&--2{
			&::after{
				background-image: url('../../assets/svg/decorator2.svg');
			}
		}
	}
}

@keyframes comodin {
	0% {
		transform: rotate(0);
	} 
	100% {
		transform: rotate(360deg);
	}
}
</style>